export const ATTRIBUTION_METHODS = {
  MCAR: "MCAR",
  MCTE: "MCTE",
}

export function computeAttributionMethod(isActive) {
  return isActive ? ATTRIBUTION_METHODS.MCTE : ATTRIBUTION_METHODS.MCAR
}
